import React, { useState } from "react";
import { Link } from "react-router-dom";
import Novatales from "../../assets/images/Novatales-1.png";
import Endula from "../../assets/images/Endula-1.png";
import Conceiva from "../../assets/images/conceiva-1.png";
import portfolio from "../../assets/images/myPortfolio.png";
import Magnaid from "../../assets/images/Magnaid.png";
import MoonDew from "../../assets/images/MoonDew.png";
import Navatris from "../../assets/images/Navatris.png";
import Aura from "../../assets/images/Aura.png";
import CDC from "../../assets/images/CDC.png";
export default function Projects() {
  const [showAll, setShowAll] = useState(false);

  const projects = [
    {
      title: "My Portfolio",
      img: portfolio,
      link: "https://divyasrikandavalli.netlify.app/",
      role: "Frontend development & UI implementation",
    },
    {
      title: "Moon Dew",
      img: MoonDew,
      link: "https://moondew-dev.novatales.com/",
      role: "Frontend & Backend development",
    },
    {
      title: "Aura by Tranquillo",
      img: Aura,
      link: "https://aurabytranquillo.in/",
      role: "Website UI development",
    },
    {
      title: "NovaTales Media",
      img: Novatales,
      link: "https://www.novatales.com/",
      role: "Frontend development & UI implementation",
    },
    {
      title: "Endula Infra",
      img: Endula,
      link: "https://endulainfra.com/",
      role: "Responsive UI development",
    },
    {
      title: "Conceiva Fertility",
      img: Conceiva,
      link: "https://www.conceivafertility.com/",
      role: "React UI development",
    },
    {
      title: "Magnaid Hospitals",
      img: Magnaid,
      link: "https://www.magnaid.com/",
      role: "Website UI implementation",
    },
    {
      title: "Navatris Investments",
      img: Navatris,
      link: "https://optimusinvestments.novatales.com/",
      role: "Frontend development",
    },
    {
      title: "Citrus Diagnostics Center",
      img: CDC,
      link: "https://citrusdiagnosticcenter.com/",
      role: "Frontend implementation",
    },
  ];

  const visibleProjects = showAll ? projects : projects.slice(0, 3);

  return (
    <section className="py-8 xl:py-16 text-[#F8F8F8]" id="projects">
      <div className="relative max-w-7xl mx-auto px-8 2xl:px-0">
        {/* TOP CONTENT */}
        <div className="flex flex-col lg:flex-row justify-between items-start gap-5 xl:gap-14">
          <div className="flex-1">
            <div
              className="flex items-center gap-2 mb-4"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <span className="w-2.5 h-2.5 rounded-full bg-[#86ff9f]" />
              <p className="text-[15px] font-medium">Projects</p>
            </div>

            <h2
              className="text-[24px] md:text-[32px] xl:text-[42px] font-semibold leading-tight"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              Showcase of my latest <br />
              <span className="bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent">
                development work
              </span>
            </h2>
          </div>

          {/* RIGHT */}
          <div className="flex-1 max-w-xl">
            <p
              className="text-[#F8F8F8] text-[16px] leading-[1.6em] mb-8"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              These projects reflect my experience building responsive websites
              and web applications using modern technologies.
            </p>

            <button
              onClick={() => setShowAll(!showAll)}
              className="px-8 py-3 rounded-full text-[#0C1F20] font-semibold text-[16px] bg-[linear-gradient(90deg,#6cfcb5,#F0FF6C,#6cfcb5)]
    bg-[length:200%_100%]
    bg-left
    transition-all duration-500 ease-in-out
    hover:bg-right"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              {showAll ? "Show Less" : "View All Projects"}
            </button>
          </div>
        </div>

        {/* CARDS */}
        <div
          className="mt-10 xl:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12"
          data-aos="fade-up"
          data-aos-delay="600"
        >
          {visibleProjects.map((item, i) => (
            <div key={i} className="group">
              <div className="rounded-[26px] overflow-hidden mb-6">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-[330px] object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              <h3 className="text-[18px] md:text-[20px] font-semibold leading-snug mb-4">
                {item.title}
              </h3>
              <p className="text-[#F8F8F8] text-[16px] leading-[1.6em] mt-2">
                {item.role}
              </p>
              <Link
                to={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#86ff9f] font-medium mt-3"
              >
                Visit Website →
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
